<template>
    <div class="modal-box update-order" v-loading="loading">
        <div class="modal-box-inner">
          <div class="modal-box-content-form-row">
            <div class="modal-box-content-form-text">
              change order status <br/>
              <span>{{this.data.ids.length}} {{this.data.ids.length === 1 ? 'item' : 'items'}} selected</span>
            </div>
          </div>
            <div class="modal-box-content update-order">
                <el-form ref="form" :rules="rules" :model="form" @submit.prevent.native="formSubmit('form')">

                    <el-form-item>
                        <el-select prop="status" v-model="form.status" placeholder="select">
                            <el-option
                                    v-for="item in statuses"
                                    :key="item"
                                    :label="item"
                                    :value="item">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <div class="modal-box-actions">
                        <button native-type="submit" type="primary" class="modal-box-actions-item button">save</button>

                        <button native-type="button" @click.prevent="close" type="text" class="modal-box-actions-item button white">cancel</button>
                    </div>

                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import { HTTP } from '@/services/api'
import { EventBus } from '@/services/eventbus'

export default {
  props: {
    header: {
      type: [Boolean, Object]
    },
    data: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  name: 'OrderUpdateModal',
  data () {
    return {
      loading: false,
      form: {
        ids: [],
        status: null
      },
      statuses: ['requested', 'delivered', 'available'],
      rules: {
        status: [
          { required: true, message: 'Please select status', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    if (typeof this.data.ids !== 'undefined') {
      this.form.ids = this.data.ids
    }
  },
  mounted () {
    document.body.addEventListener('keyup', e => {
      if (e.keyCode === 27) {
        this.close()
      }
    })
  },
  methods: {
    formSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true
          HTTP({
            method: 'PUT',
            url: '/api/v1/order-items',
            crossdomain: true,
            data: {
              ids: this.form.ids,
              status: this.form.status
            }
          })
            .then(response => {
              this.loading = false
              if (response.data) {
                this.$notify({
                  // title: 'Success',
                  message: 'Orders updated',
                  type: 'success',
                  position: 'bottom-right',
                  duration: 1750
                })
                this.close()
                EventBus.$emit('reload-orders')
              }
            })
            .catch(error => {
              this.loading = false
              this.$notify({
                // title: 'Error',
                dangerouslyUseHTMLString: true,
                message: error.response.data ? this.parseErrorMessage(error.response.data.error) : 'Error occured. Please try later',
                type: 'error',
                position: 'bottom-right',
                duration: 1750
              })
            })
        } else {
          return false
        }
      })
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>
